import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { signInRequest, signOutRequest } from '@actions/auth-actions';
import { useAppSelector } from '@helpers/redux';
import { AuthState } from '@reducers/types/auth-state';
import { getAuthState } from '@selectors/auth-selector';
import { removeStorage } from '@utils/local-store';
import { LS_KEYS } from '@constants/local-store';
import { UserState } from '@reducers/types/user-state';
import { getUserState } from '@selectors/user-selector';
import { ROUTES } from '@constants/routes';

interface UseAuth {
  requested: boolean;
  isLogin: boolean;
  signIn: (phone: string, password: string) => void;
  signOut: () => void;
  user: any;
}

export const useAuth = (): UseAuth => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const data = useAppSelector<AuthState>(getAuthState);
  const user = useAppSelector<UserState>(getUserState);

  const requested = data.request;
  const isLogin = Boolean(user.data?.token);

  const signIn = (phone: string, password: string) =>
    dispatch(signInRequest(phone, password));

  const signOut = () => {
    dispatch(signOutRequest());
    removeStorage(LS_KEYS.AUTH_TOKEN);
    navigate(ROUTES.HOME);
  };

  return {
    user,
    requested,
    isLogin,
    signIn,
    signOut,
  };
};
